// @ai-generated 2026-08-05T00:00:00+00:00 by malte.ulfers@tngtech.com using Claude Opus 4.7
import { IconChevronDown, IconChevronRight } from '@tabler/icons-react';
import type { ReactNode } from 'react';
import { CARD_BASE_CLASSES } from './accent';

interface ConditionCardProps {
    accent: { border: string; icon: string };
    children: ReactNode;
}

export function ConditionCard({ accent, children }: ConditionCardProps) {
    return <div className={`${CARD_BASE_CLASSES} ${accent.border} pl-3 py-2 pr-2`}>{children}</div>;
}

interface ConditionCardHeaderProps {
    expanded: boolean;
    onToggle: () => void;
    icon: ReactNode;
    title: ReactNode;
    trailing?: ReactNode;
}

export function ConditionCardHeader({ expanded, onToggle, icon, title, trailing }: ConditionCardHeaderProps) {
    return (
        <button
            type="button"
            onClick={onToggle}
            className="flex w-full items-center gap-2 text-left text-sm text-(--mantine-color-text-5) hover:text-(--mantine-color-text-7)"
            aria-expanded={expanded}
        >
            {expanded ? (
                <IconChevronDown size={14} className="shrink-0 text-(--mantine-color-text-4)" />
            ) : (
                <IconChevronRight size={14} className="shrink-0 text-(--mantine-color-text-4)" />
            )}
            {icon}
            <span>{title}</span>
            {trailing}
        </button>
    );
}
